import { useTranslate } from "@refinedev/core";
import { useBoundStore } from "@/store";
import { useEffect } from "react";
import { AuthPage, AuthRightPanel } from "./components/AuthLayout";
import { CoverflowCarousel } from "./components/CoverflowCarousel";
import { AuthFormPanel } from "./components/AuthFormPanel";
import { VerificationForm } from "./components/VerificationForm";
import { safeAtob } from "./utils/safeAtoB";

export const EmailVerificationPage = () => {
  const t = useTranslate();
  const setSidebarCollapsed = useBoundStore(
    (state) => state.setSidebarCollapsed
  );

  const searchParams = new URLSearchParams(document.location.search);
  const fromLogin = searchParams.get("from") === "login";
  const email = safeAtob(searchParams.get("email") ?? "");

  useEffect(() => {
    setSidebarCollapsed(true);
    return () => {
      setSidebarCollapsed(false);
    };
  }, [setSidebarCollapsed]);

  return (
    <AuthPage>
      <CoverflowCarousel />
      <AuthRightPanel>
        <AuthFormPanel title={t("pages.auth.verification.title")}>
          <VerificationForm email={email} fromLogin={fromLogin} />
        </AuthFormPanel>
      </AuthRightPanel>
    </AuthPage>
  );
};
